import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "regionalBlocks",
  listPath: "regional/blocks",
  adminPath: "regional/blocks",
  legacy: {
    data: "regionalBlocks",
    count: "count",
    fetch: "fetchRegionalBlocks",
    create: "createOneRegionalBlocks",
    update: "updateRegionalBlocks",
    remove: "deleteRegionalBlocks",
    updateState: "updateRegionalBlocksState",
  },
});

export const RegionalBlocksProvider = Provider;
export const useRegionalBlocksContext = useValue;
